import { Component } from '@angular/core'
import { PAGE_NAME } from 'globals/store/permissions.data'
import { traceNames } from 'src/app/services/performance.tracking.data'
import { filterPageTypes } from 'src/app/store/filters.era'
import { TaskTimeComponent } from './task-time.component';

@Component({
    selector: 'my-task-time-page',
    template: `<task-time [isMyTasks]="true" [page_name]="pageName" [traceName]="traceName" [filterPage]="filterPage"></task-time>`,
    styleUrls: ['../../page.pass-through.scss'],
    standalone: true,
    imports: [TaskTimeComponent],
})
export class MyTaskTimeComponent {
    filterPage = filterPageTypes.myTasks;
    pageName = PAGE_NAME.myTaskTime
    traceName = traceNames.viewMyTasksTime
}

